const routes = [{
  path: '/marketing',
  component: () => import('@/views/marketing'),
  name: 'marketing',
  meta: {
    title: '营销方案'
  }
}, {
  path: '/marketing/project',
  component: () => import('@/views/marketing/project'),
  name: 'marketing-project',
  meta: {
    title: '项目管理'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/marketing.js